import AppLoader from '@/components/AppLoader';
import useMicrosoftOauthRedirect from './useMicrosoftOauthRedirect';

export function MicrosoftOauthRedirect() {
	useMicrosoftOauthRedirect();

	return <AppLoader />;
}
